import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class deactivateComponentService {
  public switchDeactivate: Subject<boolean> = new Subject<boolean>();

  public hasUnsavedChanges: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  clear() {
    this.switchDeactivate.complete();
    this.switchDeactivate = new Subject<boolean>();
  }
}
